import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../Styling/Navbar.css';
import Logo from '../Image/Logo/nlogo.png';

const Navbar = () => {
  const [click, setClick] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 960);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const onMouseEnter = () => {
    if (!isMobile) {
      setDropdown(true);
    }
  };

  const onMouseLeave = () => {
    if (!isMobile) {
      setDropdown(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 960);
      if (window.innerWidth > 960) {
        setClick(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const services = [
    {
      name: 'Application Development',
      path: '/services/application-development'
    },
    {
      name: 'Software Testing',
      path: '/services/software-testing'
    },
    {
      name: 'IT Consulting',
      path: '/services/it-consulting'
    },
    {
      name: 'ERP Implementation',
      path: '/services/erp-implementation'
    },
    {
      name: 'Digital Marketing',
      path: '/services/digital-marketing'
    },
    {
      name: 'IT Training',
      path: '/services/it-training'
    }
  ];

  return (
    <nav className={`ql-navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="ql-navbar-container">
        <Link to="/" className="ql-navbar-logo" onClick={closeMobileMenu}>
          <img src={Logo} alt="QuantifyLogic Logo" className="logo-image" />
          <span className="logo-text">QuantifyLogic Solutions</span>
        </Link>
        <div className="ql-menu-icon" onClick={handleClick}>
          <div className={`ql-hamburger ${click ? 'open' : ''}`}> <span></span><span></span><span></span> </div>
        </div>
        {/* Desktop nav menu only */}
        {!isMobile && (
          <ul className="ql-nav-menu">
            <li className="ql-nav-item">
              <Link to="/" className={`ql-nav-link ${isActive('/')}`} onClick={closeMobileMenu}>Home</Link>
            </li>
            <li className="ql-nav-item" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
              <Link to="/services" className={`ql-nav-link ${isActive('/services')}`}>Services</Link>
              <ul className={`ql-dropdown-menu ${dropdown ? 'show' : ''}`}>
                {services.map((service, index) => (
                  <li key={index} className="ql-dropdown-item">
                    <Link to={service.path} className={`ql-dropdown-link ${isActive(service.path)}`} onClick={closeMobileMenu}>{service.name}</Link>
                  </li>
                ))}
              </ul>
            </li>
            <li className="ql-nav-item">
              <Link to="/aboutus" className={`ql-nav-link ${isActive('/about')}`} onClick={closeMobileMenu}>About Us</Link>
            </li>
            <li className="ql-nav-item">
              <Link to="/contactus" className={`ql-nav-link ${isActive('/contact')}`} onClick={closeMobileMenu}>Contact</Link>
            </li>
          </ul>
        )}
      </div>
      {/* Mobile menu panel rendered outside the container */}
      {isMobile && click && (
        <div className="ql-mobile-menu-panel">
          <div className="ql-nav-mobile-logo" style={{
            display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: 0, padding: '0 0 8px 12px', boxSizing: 'border-box', borderBottom: '1px solid #e5e7eb', background: '#fff'
          }}>
            <img src={Logo} alt="QuantifyLogic Logo" style={{ height: 48, margin: 0, padding: 0, display: 'block' }} />
            <span style={{ fontWeight: 700, fontSize: 20, color: '#2563eb', marginTop: 4 }}>QuantifyLogic Solutions</span>
          </div>
          <ul className="ql-nav-menu active">
            <li className="ql-nav-item">
              <Link to="/" className={`ql-nav-link ${isActive('/')}`} onClick={closeMobileMenu}>Home</Link>
            </li>
            <li className="ql-nav-item">
              <Link to="/services" className={`ql-nav-link ${isActive('/services')}`} onClick={closeMobileMenu}>Services</Link>
            </li>
            <li className="ql-nav-item">
              <Link to="/aboutus" className={`ql-nav-link ${isActive('/about')}`} onClick={closeMobileMenu}>About Us</Link>
            </li>
            <li className="ql-nav-item">
              <Link to="/contactus" className={`ql-nav-link ${isActive('/contact')}`} onClick={closeMobileMenu}>Contact</Link>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar; 